export default class LeadPageVariant {
  static get Default() {
    return this.getInstance('default');
  }

  static get ComingSoon() {
    return this.getInstance('comingSoon');
  }

  static get Basic() {
    return this.getInstance('basic');
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new LeadPageVariant(key);
    }

    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return this.name;
  }
}

Object.defineProperty(LeadPageVariant, 'instances', { value: {} });
